import { memo, useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/authContext";
import { useUserStore } from "../../../../store/user";
import { useLocation } from "react-router";
import { useNavigate, useSearchParams } from "react-router-dom";
import SelectWithCheckboxes from "../../../../components/SelectWithCheckboxes/SelectWithCheckboxes";
import "./MembersList.scss";

export default memo(function MembersList({
  multiple = true,
  defaultAssignee = false,
  onChange = () => {},
}) {
  const { currentUser } = useContext(AuthContext);

  const { members, getMembers, setSelectedAssignees } = useUserStore();

  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [defaultOptions, setDefaultOptions] = useState(null);

  useEffect(() => {
    // get members
    if (members == null) {
      getMembers().catch((err) => {
        console.error(err);
      });
    }
  }, []);

  const formatMemberList = useCallback(() => {
    if (members == null) return;
    return members.map((member) => {
      return { title: member?.name, value: member?.id };
    });
  }, [members]);

  const checkAssigneeInUrl = useCallback(() => {
    let assigneeStr = searchParams.get("assignee");
    if (assigneeStr) {
      let arr = assigneeStr.split(",");
      arr = arr.map((id) => {
        return parseInt(id);
      });
      setSelectedAssignees(arr);

      let defaultValues = formatMemberList().filter((el) => {
        return arr.includes(el.value);
      });
      setDefaultOptions(defaultValues ?? undefined);
      return true;
    }
    setDefaultOptions(undefined);
    return false;
  }, [members]);

  useEffect(() => {
    if (members != null) {
      if (defaultAssignee) {
        setSelectedAssignees([defaultAssignee]);
        let defaultValues = formatMemberList().filter((el) => {
          return el.value === defaultAssignee;
        });
        if (defaultValues && defaultValues.length > 0 && !multiple) {
          setDefaultOptions(defaultValues[0] ?? undefined);
        } else {
          setDefaultOptions(defaultValues ?? undefined);
        }
      } else {
        //check url
        if (!checkAssigneeInUrl()) {
          setSelectedAssignees([currentUser?.id]);
        }
      }
    }
  }, [members]);

  const onChangeAssignee = useCallback((values) => {
    if (multiple && !defaultAssignee) {
      let arr = values.map((el) => {
        return el.value;
      });

      if (arr.length > 0) {
        const params = new URLSearchParams({ assignee: arr.join(",") });
        navigate(
          { pathname: location.pathname, search: params.toString() },
          { replace: true },
        );
        setSelectedAssignees(arr);
      } else {
        navigate({ pathname: location.pathname }, { replace: true });
        setSelectedAssignees([currentUser?.id]);
      }
    } else {
      setSelectedAssignees([values]);
    }

    onChange(values);
  }, []);

  return (
    <div className="members-list">
      {defaultOptions !== null && (
        <SelectWithCheckboxes
          options={formatMemberList()}
          onChangeHandler={onChangeAssignee}
          defaultValue={defaultOptions}
          size="small"
          width="100%"
          multiple={multiple}
        />
      )}
    </div>
  );
});
